import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const teamMembers = [
  {
    name: 'Abdul Majeed P',
    role: 'Chairman',
    image: 'https://aecagra.edu.in/wp-content/uploads/2023/05/chairman-sir-1024x717-1-e1685096050995.jpg',
    quote: 'Dedicated to building an institution rooted in authentic Islamic scholarship.',
  },
  {
    name: 'Kuryan Pk',
    role: 'Manager',
    image: 'https://itsengg.edu.in/chairman-1.png',
    quote: 'Committed to operational excellence and nurturing a culture of learning.',
  },
  {
    name: 'Shilpa Thomas',
    role: 'Principal',
    image: 'https://www.k12digest.com/wp-content/uploads/2020/09/Pallavi-Upadhyaya-PrincipalDPS-RNE-Ghaziabad-1_800x480-550x330.jpg',
    quote: 'Empowering students to achieve their highest potential through holistic education.',
  },
];

export function Managment() {
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);
  const headerRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Header
      gsap.fromTo(headerRef.current,
        { y: 30, opacity: 0 },
        {
          y: 0, opacity: 1, duration: 0.8, ease: 'power3.out',
          scrollTrigger: { trigger: sectionRef.current, start: 'top 80%', toggleActions: 'play none none reverse' },
        }
      );

      // Cards
      cardsRef.current.forEach((card, i) => {
        if (!card) return;
        gsap.fromTo(card,
          { y: 80, opacity: 0, scale: 0.95 },
          {
            y: 0, opacity: 1, scale: 1, duration: 0.8, ease: 'power3.out', delay: i * 0.15,
            scrollTrigger: { trigger: card, start: 'top 85%', toggleActions: 'play none none reverse' },
          }
        );
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-white py-20 sm:py-24 relative overflow-hidden">
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-pumpkinToast-200/25 rounded-full blur-[140px]" />
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-[#2a1273]/8 rounded-full blur-[120px]" />

      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div ref={headerRef} className="text-left mb-14 opacity-0">
          <span className="inline-flex items-center px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-[#2a1273] bg-[#2a1273]/8 rounded-full border border-[#2a1273]/15 mb-4">
            Leadership
          </span>
          <h2 className="font-AndoraModernSerif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2a1273] mb-3">
            Our Management
          </h2>
          <p className="text-gray-500 max-w-xl text-base sm:text-lg">
            Meet the visionary leaders guiding Darul Hadees towards excellence in education and research.
          </p>
        </div>

        {/* Team grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              ref={el => (cardsRef.current[index] = el)}
              className="group bg-gray-50 rounded-2xl overflow-hidden border border-gray-100 hover:shadow-2xl hover:-translate-y-2 transition-all duration-400 opacity-0"
            >
              {/* Image container */}
              <div className="relative h-64 sm:h-72 overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 via-transparent to-transparent" />
                {/* Role badge */}
                <span className="absolute bottom-4 left-4 px-3 py-1 bg-pumpkinToast-500 text-white text-xs font-semibold rounded-full shadow-lg">
                  {member.role}
                </span>
              </div>

              {/* Info */}
              <div className="p-6 sm:p-7">
                <h3 className="text-xl font-bold text-gray-900 font-AndoraModernSerif mb-2">
                  {member.name}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed italic">
                  "{member.quote}"
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
